import {denormFn, normFn} from '../normalizerSupport';
import type * as Types from './types';

export const normalize = normFn<Types.TempSelectionObjSchema>(
  'temp-selections',
  whole => whole
);

export const denormalize = denormFn<Types.TempSelectionObjSchema>(part => part);
